import { render, staticRenderFns } from "./CreateTypologySizeForTax.vue?vue&type=template&id=7b2bf686&scoped=true&"
import script from "./CreateTypologySizeForTax.vue?vue&type=script&lang=js&"
export * from "./CreateTypologySizeForTax.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b2bf686",
  null
  
)

export default component.exports